import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["icon_name", "image_url"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isBoolean, uniqueId } from 'lodash';
import { JOVE_PRICE_UNIT_PERCENT_KEY, truelyValueMap } from '../../constants/common';
import { getBrokerTypeMap } from '../../localeConstants';
import { BrokerPaymentBillTypeEnum, PartnerType, SimpleRevisionTypeEnums, SubBrokerType } from '../../shared/generated';
import { getDefaultPortalLoginIntroInfo } from '../../ui/auth/portalLogin/config';
import { getDefaultPortalIntroInfo } from '../../ui/portal/intro/config';
export var generateBrokerGeneralSettingsInitialDataInfo = function generateBrokerGeneralSettingsInitialDataInfo(data, config) {
  var _config$countryList;

  var _ref = data || {},
      name = _ref.name,
      slug = _ref.slug,
      contact_first_name = _ref.contact_first_name,
      contact_last_name = _ref.contact_last_name,
      email = _ref.email,
      website = _ref.website,
      country_id = _ref.country_id,
      broker_platform = _ref.broker_platform,
      job_title = _ref.job_title,
      phone = _ref.phone,
      broker_commission_fee = _ref.broker_commission_fee,
      broker_commission_fee_type = _ref.broker_commission_fee_type,
      broker_fee = _ref.broker_fee,
      broker_fee_type = _ref.broker_fee_type,
      broker_underwriting_fee = _ref.broker_underwriting_fee,
      broker_underwriting_fee_type = _ref.broker_underwriting_fee_type,
      broker_underwriting_fee_cap = _ref.broker_underwriting_fee_cap,
      assignee_id = _ref.assignee_id,
      isSubEntity = _ref.isSubEntity,
      payload = _ref.payload,
      parent_id = _ref.parent_id,
      activation_manager = _ref.activation_manager,
      sub_broker_type = _ref.sub_broker_type;

  var _ref2 = payload || {},
      accounting_settings = _ref2.accounting_settings,
      sub_broker_settings = _ref2.sub_broker_settings,
      portal_settings = _ref2.portal_settings,
      product_settings = _ref2.product_settings,
      payment_processing_info = _ref2.payment_processing_info;

  var brokerType = '';

  if (!!sub_broker_type) {
    if (sub_broker_type === SubBrokerType.BROKER) {
      brokerType = getBrokerTypeMap().retailBroker.value;
    } else if (sub_broker_type === SubBrokerType.PARTNER) {
      brokerType = getBrokerTypeMap().partner.value;
    }
  } else {
    brokerType = (config === null || config === void 0 ? void 0 : config.source) === PartnerType.GENERAL ? getBrokerTypeMap().partner.value : getBrokerTypeMap().wholesaleBroker.value;
  }

  return {
    name: name || '',
    slug: slug || '',
    originSlug: slug || '',
    platform: broker_platform || '',
    firstName: contact_first_name || '',
    lastName: contact_last_name || '',
    email: email || '',
    website: website || '',
    country: (config === null || config === void 0 ? void 0 : (_config$countryList = config.countryList) === null || _config$countryList === void 0 ? void 0 : _config$countryList.find(function (item) {
      return item.id === country_id;
    })) || null,
    jobTitle: job_title || '',
    phone: phone || '',
    brokerCommission: broker_commission_fee || 20,
    brokerCommissionUnit: broker_commission_fee_type || JOVE_PRICE_UNIT_PERCENT_KEY,
    brokerFee: broker_fee || 0,
    brokerFeeUnit: broker_fee_type || JOVE_PRICE_UNIT_PERCENT_KEY,
    underwritingFee: broker_underwriting_fee || 5,
    underwritingFeeUnit: broker_underwriting_fee_type || JOVE_PRICE_UNIT_PERCENT_KEY,
    underwritingFeeCap: broker_underwriting_fee_cap || 0,
    assignee: assignee_id ? {
      value: assignee_id,
      label: ''
    } : null,
    isSubEntity: isSubEntity,
    allowSubBrokerQuote: !!(sub_broker_settings !== null && sub_broker_settings !== void 0 && sub_broker_settings.allow_update_quote_payment),
    allowSubBrokerUpdateBranding: !!(sub_broker_settings !== null && sub_broker_settings !== void 0 && sub_broker_settings.allow_update_website_files),
    disallowViewSubBrokersInPortal: !!(sub_broker_settings !== null && sub_broker_settings !== void 0 && sub_broker_settings.disallow_view_sub_brokers_in_portal),
    exclusiveQuoteRights: !!(sub_broker_settings !== null && sub_broker_settings !== void 0 && sub_broker_settings.exclusive_quote_rights),
    autoApproveLegalEntity: !!(sub_broker_settings !== null && sub_broker_settings !== void 0 && sub_broker_settings.auto_approve_legal_entity),
    hidePortalHomeJoveLogo: !!(portal_settings !== null && portal_settings !== void 0 && portal_settings.hide_jove_logo_in_portal_homepage),
    showPartnersInPortal: !!(portal_settings !== null && portal_settings !== void 0 && portal_settings.show_partners_in_portal),
    allowAddR2RProducts: !!(product_settings !== null && product_settings !== void 0 && product_settings.allow_r2r),
    payload: payload,
    parent_id: parent_id,
    activationManager: activation_manager ? {
      value: activation_manager,
      label: ''
    } : null,
    accountingFirstName: (accounting_settings === null || accounting_settings === void 0 ? void 0 : accounting_settings.accounting_first_name) || '',
    accountingLastName: (accounting_settings === null || accounting_settings === void 0 ? void 0 : accounting_settings.accounting_last_name) || '',
    accountingPhone: (accounting_settings === null || accounting_settings === void 0 ? void 0 : accounting_settings.accounting_phone) || '',
    accountingEmail: (accounting_settings === null || accounting_settings === void 0 ? void 0 : accounting_settings.accounting_email) || '',
    paymentProcessingBusinessName: (payment_processing_info === null || payment_processing_info === void 0 ? void 0 : payment_processing_info.business_name) || '',
    paymentProcessingIBANOrAccountNumber: (payment_processing_info === null || payment_processing_info === void 0 ? void 0 : payment_processing_info.iban_or_account_number) || '',
    paymentProcessingSortCode: (payment_processing_info === null || payment_processing_info === void 0 ? void 0 : payment_processing_info.sort_code) || '',
    paymentProcessingFullAddress: (payment_processing_info === null || payment_processing_info === void 0 ? void 0 : payment_processing_info.full_address) || '',
    subBrokerType: sub_broker_type,
    brokerType: !!(payload !== null && payload !== void 0 && payload.broker_type) ? payload.broker_type : brokerType
  };
};
export var generateBrokerWebsiteConfigurationInitialDataInfo = function generateBrokerWebsiteConfigurationInitialDataInfo(data, config) {
  var _data$payload, _testimonial$info_lis;

  var _ref3 = ((config === null || config === void 0 ? void 0 : config.dataSource) === 'product' ? data === null || data === void 0 ? void 0 : (_data$payload = data.payload) === null || _data$payload === void 0 ? void 0 : _data$payload.website_configuration : data === null || data === void 0 ? void 0 : data.website_configuration) || {},
      footer = _ref3.footer,
      legal_term = _ref3.legal_term,
      social_media = _ref3.social_media,
      additional_information = _ref3.additional_information,
      header_information = _ref3.header_information,
      testimonial = _ref3.testimonial,
      footer_information = _ref3.footer_information,
      partner_statement = _ref3.partner_statement;

  var _ref4 = ((config === null || config === void 0 ? void 0 : config.dataSource) === 'product' ? data === null || data === void 0 ? void 0 : data.payload : data === null || data === void 0 ? void 0 : data.website_configuration) || {},
      quote_terms_document = _ref4.quote_terms_document,
      privacy_policy_document = _ref4.privacy_policy_document;

  var _ref5 = additional_information || {},
      copyright = _ref5.copyright,
      company_info = _ref5.company_info,
      registered_address = _ref5.registered_address,
      registerd_number = _ref5.registerd_number;

  var _ref6 = header_information || {},
      logo_height = _ref6.logo_height,
      quote_button_text = _ref6.quote_button_text,
      quote_button_font_size = _ref6.quote_button_font_size,
      quote_button_text_color = _ref6.quote_button_text_color,
      quote_button_bg_color = _ref6.quote_button_bg_color,
      hide_header = _ref6.hide_header;

  var _ref7 = (testimonial === null || testimonial === void 0 ? void 0 : (_testimonial$info_lis = testimonial.info_list) === null || _testimonial$info_lis === void 0 ? void 0 : _testimonial$info_lis[0]) || {},
      content = _ref7.content,
      name = _ref7.name,
      job_title = _ref7.job_title,
      company_name = _ref7.company_name;

  var _ref8 = footer_information || {},
      hide_footer = _ref8.hide_footer,
      entity_countries = _ref8.entity_countries;

  var _ref9 = partner_statement || {},
      enabled = _ref9.enabled,
      title = _ref9.title,
      paragraph_list = _ref9.paragraph_list,
      background_color = _ref9.background_color,
      text_color = _ref9.text_color,
      font_size = _ref9.font_size,
      default_expanded = _ref9.default_expanded;

  return {
    id: data === null || data === void 0 ? void 0 : data.id,
    footerDisplayType: footer || 'default',
    introductionList: (legal_term || []).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        id: uniqueId()
      });
    }),
    socialMediaList: (social_media || []).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        id: uniqueId()
      });
    }),
    copyrightText: copyright || '',
    companyFullName: company_info || '',
    registeredAddress: registered_address || '',
    registeredNumber: registerd_number || '',
    hideLandingPageHeader: !!hide_header,
    landingPageHeaderLogoHeight: logo_height || '70px',
    landingPageHeaderQuoteButtonText: quote_button_text || '',
    landingPageHeaderQuoteButtonFontSize: quote_button_font_size || '14px',
    landingPageHeaderQuoteButtonTextColor: quote_button_text_color || '#ffffff',
    landingPageHeaderQuoteButtonBGColor: quote_button_bg_color || '#CD0D47',
    customersSayTitle: (testimonial === null || testimonial === void 0 ? void 0 : testimonial.title) || '',
    hideTestimonial: !!(testimonial !== null && testimonial !== void 0 && testimonial.hide_testimonial),
    customersSayContent: content || '',
    customersSayCustomerName: name || '',
    customersSayCustomerJobTitle: job_title || '',
    customersSayCustomerCompanyName: company_name || '',
    partnerStatementEnabled: isBoolean(enabled) ? enabled : false,
    partnerStatementDefaultExpanded: isBoolean(default_expanded) ? default_expanded : true,
    partnerStatementTitle: title || '',
    partnerStatementParagraphList: (paragraph_list || []).map(function (item) {
      return {
        text: (item === null || item === void 0 ? void 0 : item.text) || '',
        id: uniqueId()
      };
    }),
    partnerStatementBackgroundColor: background_color || '#FFFFFF',
    partnerStatementTextColor: text_color || '#202020',
    partnerStatementFontSize: font_size || '14px',
    termsAndConditionsFile: quote_terms_document || null,
    termsAndConditionsUploadType: (quote_terms_document === null || quote_terms_document === void 0 ? void 0 : quote_terms_document.revision_type) || SimpleRevisionTypeEnums.DOC_FILE,
    termsAndConditionsCustomUrl: (quote_terms_document === null || quote_terms_document === void 0 ? void 0 : quote_terms_document.file_url) || '',
    privacyPolicyUploadType: (privacy_policy_document === null || privacy_policy_document === void 0 ? void 0 : privacy_policy_document.revision_type) || SimpleRevisionTypeEnums.DOC_FILE,
    privacyPolicyCustomUrl: (privacy_policy_document === null || privacy_policy_document === void 0 ? void 0 : privacy_policy_document.file_url) || '',
    privacyPolicyFile: privacy_policy_document || null,
    hideLandingPageFooter: !!hide_footer,
    landingPageFooterEntityCountries: entity_countries || []
  };
};
export var generateBrokerEmailSettingsInitialDataInfo = function generateBrokerEmailSettingsInitialDataInfo(data, config) {
  var _ref10 = data || {},
      sub_broker_type = _ref10.sub_broker_type,
      slug = _ref10.slug;

  var _ref11 = (data === null || data === void 0 ? void 0 : data.payload) || {},
      quote_email_settings = _ref11.quote_email_settings,
      button_settings = _ref11.button_settings,
      header_settings = _ref11.header_settings,
      content_settings = _ref11.content_settings;

  var _ref12 = quote_email_settings || {},
      quotes_from_broker_portal = _ref12.quotes_from_broker_portal,
      quotes_from_landing_page = _ref12.quotes_from_landing_page,
      policy_email_settings = _ref12.policy_email_settings,
      referral_email_settings = _ref12.referral_email_settings,
      reply_email = _ref12.reply_email,
      sender_email = _ref12.sender_email,
      sender_name = _ref12.sender_name;

  var _ref13 = button_settings || {},
      primary_bg_color = _ref13.primary_bg_color,
      primary_text_color = _ref13.primary_text_color;

  var _ref14 = header_settings || {},
      custom_image_url = _ref14.custom_image_url;

  var _ref15 = content_settings || {},
      official_website = _ref15.official_website,
      book_meeting_address = _ref15.book_meeting_address,
      contact_email_address = _ref15.contact_email_address,
      contact_phone_number = _ref15.contact_phone_number;

  return {
    dropoutBeforeQuotedFormLandingPage: !!(quotes_from_landing_page !== null && quotes_from_landing_page !== void 0 && quotes_from_landing_page.dropout_before_quoted),
    dropoutBeforePurchaseFormLandingPage: !!(quotes_from_landing_page !== null && quotes_from_landing_page !== void 0 && quotes_from_landing_page.dropout_before_purchase),
    otherStatusFormLandingPage: !!(quotes_from_landing_page !== null && quotes_from_landing_page !== void 0 && quotes_from_landing_page.others),
    purchasedLandingPage: !!(quotes_from_landing_page !== null && quotes_from_landing_page !== void 0 && quotes_from_landing_page.purchased),
    dropoutBeforeQuotedFormBrokerPortal: !!(quotes_from_broker_portal !== null && quotes_from_broker_portal !== void 0 && quotes_from_broker_portal.dropout_before_quoted),
    dropoutBeforePurchaseFormBrokerPortal: !!(quotes_from_broker_portal !== null && quotes_from_broker_portal !== void 0 && quotes_from_broker_portal.dropout_before_purchase),
    otherStatusFormBrokerPortal: !!(quotes_from_broker_portal !== null && quotes_from_broker_portal !== void 0 && quotes_from_broker_portal.others),
    purchasedBrokerPortal: !!(quotes_from_broker_portal !== null && quotes_from_broker_portal !== void 0 && quotes_from_broker_portal.purchased),
    policyRenewal: isBoolean(policy_email_settings === null || policy_email_settings === void 0 ? void 0 : policy_email_settings.policy_renewal) ? policy_email_settings.policy_renewal : true,
    policyUpdate: isBoolean(policy_email_settings === null || policy_email_settings === void 0 ? void 0 : policy_email_settings.policy_update) ? policy_email_settings.policy_update : true,
    policyCancellation: isBoolean(policy_email_settings === null || policy_email_settings === void 0 ? void 0 : policy_email_settings.policy_cancellation) ? policy_email_settings.policy_cancellation : true,
    referralRelatedEmail: isBoolean(referral_email_settings === null || referral_email_settings === void 0 ? void 0 : referral_email_settings.referral_related_email) ? referral_email_settings.referral_related_email : false,
    senderEmail: sender_email || slug || '',
    replyEmail: reply_email || '',
    senderName: sender_name || '',
    emailOfficialWebsite: official_website || '',
    emailBookMeetingAddress: book_meeting_address || '',
    emailContactEmailAddress: contact_email_address || '',
    emailContactPhoneNumber: contact_phone_number || '',
    emailButtonPrimaryBackgroundColor: primary_bg_color || '#0E35D1',
    emailButtonPrimaryTextColor: primary_text_color || '#ffffff',
    emailHeaderBackgroundImage: custom_image_url || null,
    subBrokerType: sub_broker_type
  };
};
export var generateBrokerQuoteSettingsInitialDataInfo = function generateBrokerQuoteSettingsInitialDataInfo(data, config) {
  var _ref16 = (data === null || data === void 0 ? void 0 : data.payload) || {},
      bank_transfer_info = _ref16.bank_transfer_info,
      payment_settings = _ref16.payment_settings,
      quote_process_settings = _ref16.quote_process_settings;

  var _ref17 = bank_transfer_info || {},
      account_country = _ref17.account_country,
      bank_name = _ref17.bank_name,
      bank_branch_address = _ref17.bank_branch_address,
      account_name = _ref17.account_name,
      account_number = _ref17.account_number,
      sort_code = _ref17.sort_code,
      iban = _ref17.iban,
      nib = _ref17.nib,
      swift = _ref17.swift;

  var _ref18 = payment_settings || {},
      quotes_from_landing_page = _ref18.quotes_from_landing_page,
      quotes_from_broker_portal = _ref18.quotes_from_broker_portal,
      quotes_from_acturis = _ref18.quotes_from_acturis,
      first_payment_delayed_inception_date = _ref18.first_payment_delayed_inception_date,
      monthly_payment_min_amount = _ref18.monthly_payment_min_amount,
      premium_override_min_amount_type = _ref18.premium_override_min_amount_type,
      premium_override_min_amount = _ref18.premium_override_min_amount,
      disabled_payment_methods = _ref18.disabled_payment_methods;

  var _ref19 = quote_process_settings || {},
      tax_number_must_be_filled = _ref19.tax_number_must_be_filled,
      quote_disclaimer_highlight_text = _ref19.quote_disclaimer_highlight_text,
      quote_disclaimer_content = _ref19.quote_disclaimer_content,
      quote_disclaimer_enabled = _ref19.quote_disclaimer_enabled,
      use_english_when_accessing_quote_first_time = _ref19.use_english_when_accessing_quote_first_time,
      hide_broker_fee = _ref19.hide_broker_fee,
      quote_website_body_background_color = _ref19.quote_website_body_background_color,
      show_agreement_checkbox = _ref19.show_agreement_checkbox,
      hide_business_registration_number = _ref19.hide_business_registration_number,
      quote_exit_redirect_url = _ref19.quote_exit_redirect_url;

  return {
    firstPaymentDelayedInceptionDate: isBoolean(first_payment_delayed_inception_date) ? first_payment_delayed_inception_date : false,
    monthlyPaymentMinAmount: monthly_payment_min_amount !== null && monthly_payment_min_amount !== void 0 ? monthly_payment_min_amount : null,
    disabledPaymentMethods: disabled_payment_methods || [],
    premiumOverrideMinAmountType: premium_override_min_amount_type || '',
    premiumOverrideMinAmount: premium_override_min_amount !== null && premium_override_min_amount !== void 0 ? premium_override_min_amount : null,
    landingPagePaymentBillType: quotes_from_landing_page || BrokerPaymentBillTypeEnum.JOVE_BILLING,
    brokerPortalPaymentBillType: quotes_from_broker_portal || ((config === null || config === void 0 ? void 0 : config.source) === PartnerType.BROKER ? BrokerPaymentBillTypeEnum.AGENT_BILLING : BrokerPaymentBillTypeEnum.JOVE_BILLING),
    acturisPaymentBillType: quotes_from_acturis || ((config === null || config === void 0 ? void 0 : config.source) === PartnerType.BROKER ? BrokerPaymentBillTypeEnum.AGENT_BILLING : BrokerPaymentBillTypeEnum.JOVE_BILLING),
    bankTransferAccountCountry: account_country || '',
    bankTransferBankName: bank_name || '',
    bankTransferBankBranchAddress: bank_branch_address || '',
    bankTransferAccountName: account_name || '',
    bankTransferSortCode: sort_code || '',
    bankTransferAccountNumber: account_number || '',
    bankTransferIBAN: iban || '',
    bankTransferNIB: nib || '',
    bankTransferSWIFT: swift || '',
    quoteTaxNumberMustBeFilledIn: !!tax_number_must_be_filled,
    quoteDisclaimerEnabled: !!quote_disclaimer_enabled,
    quoteDisclaimerHighlightText: quote_disclaimer_highlight_text || '',
    quoteDisclaimerContent: quote_disclaimer_content || '',
    useEnglishWhenAccessingQuoteFirstTime: !!use_english_when_accessing_quote_first_time,
    quoteHideBrokerFee: !!hide_broker_fee,
    quoteWebsiteBodyBackgroundColor: quote_website_body_background_color || '#000',
    quoteShowAgreementCheckbox: !!show_agreement_checkbox,
    quoteHideBusinessRegistrationNumber: !!hide_business_registration_number,
    quoteExitRedirectUrl: quote_exit_redirect_url || ''
  };
};
export var generateBrokerProductLandingPageStatusInitialDataInfo = function generateBrokerProductLandingPageStatusInitialDataInfo(data, config) {
  var _ref20 = (data === null || data === void 0 ? void 0 : data.payload) || {},
      landing_page_status_config = _ref20.landing_page_status_config;

  var _ref21 = landing_page_status_config || {},
      need_config_landing_page = _ref21.need_config_landing_page,
      landing_page_collect_data_source = _ref21.landing_page_collect_data_source,
      landing_page_source_domain = _ref21.landing_page_source_domain,
      landing_page_source_user_name = _ref21.landing_page_source_user_name,
      landing_page_source_password = _ref21.landing_page_source_password,
      landing_page_source_email_sender_info = _ref21.landing_page_source_email_sender_info;

  return {
    needConfigLandingPage: isBoolean(need_config_landing_page) ? need_config_landing_page ? truelyValueMap.yes.value : truelyValueMap.no.value : '',
    landingPageCollectDataSource: landing_page_collect_data_source || '',
    landingPageSourceDomain: landing_page_source_domain || '',
    landingPageSourceUserName: landing_page_source_user_name || '',
    landingPageSourcePassword: landing_page_source_password || '',
    landingPageSourceEmailSenderInfo: landing_page_source_email_sender_info || ''
  };
};

var toSubBrokerPortalLocalListItem = function toSubBrokerPortalLocalListItem(item) {
  var _ref22 = item !== null && item !== void 0 ? item : {},
      icon_name = _ref22.icon_name,
      image_url = _ref22.image_url,
      rest = _objectWithoutProperties(_ref22, _excluded);

  return _objectSpread(_objectSpread(_objectSpread({}, rest), icon_name !== undefined ? {
    iconName: icon_name || ''
  } : {}), image_url !== undefined ? {
    imageUrl: image_url || ''
  } : {});
};

var withSubBrokerPortalItemId = function withSubBrokerPortalItemId(list) {
  return (list || []).map(function (item) {
    return _objectSpread(_objectSpread({}, toSubBrokerPortalLocalListItem(item)), {}, {
      id: uniqueId()
    });
  });
};

var subBrokerPortalModuleHidden = function subBrokerPortalModuleHidden(value) {
  return isBoolean(value) ? value : false;
};

var subBrokerPortalModuleDisplayType = function subBrokerPortalModuleDisplayType(value) {
  return value || 'default';
};

export var generateSubBrokerPortalCountryConfigInitialDataInfo = function generateSubBrokerPortalCountryConfigInitialDataInfo(settings, fallbackBrokerName, countryCode) {
  var _ref23, _settings$broker_name, _settings$hero_title, _settings$hero_subtit, _settings$hero_checkl, _settings$hero_image_, _settings$coverage_ti, _settings$coverage_su, _settings$coverage_it, _settings$expertise_t, _settings$expertise_c, _settings$portal_titl, _settings$portal_feat, _settings$advantage_t, _settings$advantage_i, _settings$cta_title, _settings$cta_subtitl, _settings$resources_t, _settings$resources_s, _settings$resource_it, _settings$faq_title, _settings$faq_items;

  // Defaults resolve to the country's language so a fresh country version starts with localized copy
  var defaultInfo = getDefaultPortalIntroInfo(countryCode);
  return {
    brokerName: (_ref23 = (_settings$broker_name = settings === null || settings === void 0 ? void 0 : settings.broker_name) !== null && _settings$broker_name !== void 0 ? _settings$broker_name : fallbackBrokerName) !== null && _ref23 !== void 0 ? _ref23 : defaultInfo.brokerName,
    heroHidden: subBrokerPortalModuleHidden(settings === null || settings === void 0 ? void 0 : settings.hero_hidden),
    heroDisplayType: subBrokerPortalModuleDisplayType(settings === null || settings === void 0 ? void 0 : settings.hero_display_type),
    heroTitle: (_settings$hero_title = settings === null || settings === void 0 ? void 0 : settings.hero_title) !== null && _settings$hero_title !== void 0 ? _settings$hero_title : defaultInfo.heroTitle,
    heroSubtitle: (_settings$hero_subtit = settings === null || settings === void 0 ? void 0 : settings.hero_subtitle) !== null && _settings$hero_subtit !== void 0 ? _settings$hero_subtit : defaultInfo.heroSubtitle,
    heroChecklist: ((_settings$hero_checkl = settings === null || settings === void 0 ? void 0 : settings.hero_checklist) !== null && _settings$hero_checkl !== void 0 ? _settings$hero_checkl : defaultInfo.heroChecklist).map(function (text) {
      return {
        text: text,
        id: uniqueId()
      };
    }),
    heroImageUrl: (_settings$hero_image_ = settings === null || settings === void 0 ? void 0 : settings.hero_image_url) !== null && _settings$hero_image_ !== void 0 ? _settings$hero_image_ : defaultInfo.heroImageUrl,
    coverageHidden: subBrokerPortalModuleHidden(settings === null || settings === void 0 ? void 0 : settings.coverage_hidden),
    coverageDisplayType: subBrokerPortalModuleDisplayType(settings === null || settings === void 0 ? void 0 : settings.coverage_display_type),
    coverageTitle: (_settings$coverage_ti = settings === null || settings === void 0 ? void 0 : settings.coverage_title) !== null && _settings$coverage_ti !== void 0 ? _settings$coverage_ti : defaultInfo.coverageTitle,
    coverageSubtitle: (_settings$coverage_su = settings === null || settings === void 0 ? void 0 : settings.coverage_subtitle) !== null && _settings$coverage_su !== void 0 ? _settings$coverage_su : defaultInfo.coverageSubtitle,
    coverageItems: withSubBrokerPortalItemId((_settings$coverage_it = settings === null || settings === void 0 ? void 0 : settings.coverage_items) !== null && _settings$coverage_it !== void 0 ? _settings$coverage_it : defaultInfo.coverageItems),
    expertiseHidden: subBrokerPortalModuleHidden(settings === null || settings === void 0 ? void 0 : settings.expertise_hidden),
    expertiseDisplayType: subBrokerPortalModuleDisplayType(settings === null || settings === void 0 ? void 0 : settings.expertise_display_type),
    expertiseTitle: (_settings$expertise_t = settings === null || settings === void 0 ? void 0 : settings.expertise_title) !== null && _settings$expertise_t !== void 0 ? _settings$expertise_t : defaultInfo.expertiseTitle,
    expertiseChips: withSubBrokerPortalItemId((_settings$expertise_c = settings === null || settings === void 0 ? void 0 : settings.expertise_chips) !== null && _settings$expertise_c !== void 0 ? _settings$expertise_c : defaultInfo.expertiseChips),
    portalHidden: subBrokerPortalModuleHidden(settings === null || settings === void 0 ? void 0 : settings.portal_hidden),
    portalDisplayType: subBrokerPortalModuleDisplayType(settings === null || settings === void 0 ? void 0 : settings.portal_display_type),
    portalTitle: (_settings$portal_titl = settings === null || settings === void 0 ? void 0 : settings.portal_title) !== null && _settings$portal_titl !== void 0 ? _settings$portal_titl : defaultInfo.portalTitle,
    portalFeatures: withSubBrokerPortalItemId((_settings$portal_feat = settings === null || settings === void 0 ? void 0 : settings.portal_features) !== null && _settings$portal_feat !== void 0 ? _settings$portal_feat : defaultInfo.portalFeatures),
    advantageHidden: subBrokerPortalModuleHidden(settings === null || settings === void 0 ? void 0 : settings.advantage_hidden),
    advantageDisplayType: subBrokerPortalModuleDisplayType(settings === null || settings === void 0 ? void 0 : settings.advantage_display_type),
    advantageTitle: (_settings$advantage_t = settings === null || settings === void 0 ? void 0 : settings.advantage_title) !== null && _settings$advantage_t !== void 0 ? _settings$advantage_t : defaultInfo.advantageTitle,
    advantageItems: withSubBrokerPortalItemId((_settings$advantage_i = settings === null || settings === void 0 ? void 0 : settings.advantage_items) !== null && _settings$advantage_i !== void 0 ? _settings$advantage_i : defaultInfo.advantageItems),
    ctaHidden: subBrokerPortalModuleHidden(settings === null || settings === void 0 ? void 0 : settings.cta_hidden),
    ctaDisplayType: subBrokerPortalModuleDisplayType(settings === null || settings === void 0 ? void 0 : settings.cta_display_type),
    ctaTitle: (_settings$cta_title = settings === null || settings === void 0 ? void 0 : settings.cta_title) !== null && _settings$cta_title !== void 0 ? _settings$cta_title : defaultInfo.ctaTitle,
    ctaSubtitle: (_settings$cta_subtitl = settings === null || settings === void 0 ? void 0 : settings.cta_subtitle) !== null && _settings$cta_subtitl !== void 0 ? _settings$cta_subtitl : defaultInfo.ctaSubtitle,
    resourcesHidden: subBrokerPortalModuleHidden(settings === null || settings === void 0 ? void 0 : settings.resources_hidden),
    resourcesDisplayType: subBrokerPortalModuleDisplayType(settings === null || settings === void 0 ? void 0 : settings.resources_display_type),
    resourcesTitle: (_settings$resources_t = settings === null || settings === void 0 ? void 0 : settings.resources_title) !== null && _settings$resources_t !== void 0 ? _settings$resources_t : defaultInfo.resourcesTitle,
    resourcesSubtitle: (_settings$resources_s = settings === null || settings === void 0 ? void 0 : settings.resources_subtitle) !== null && _settings$resources_s !== void 0 ? _settings$resources_s : defaultInfo.resourcesSubtitle,
    resourceItems: withSubBrokerPortalItemId((_settings$resource_it = settings === null || settings === void 0 ? void 0 : settings.resource_items) !== null && _settings$resource_it !== void 0 ? _settings$resource_it : defaultInfo.resourceItems),
    faqHidden: subBrokerPortalModuleHidden(settings === null || settings === void 0 ? void 0 : settings.faq_hidden),
    faqDisplayType: subBrokerPortalModuleDisplayType(settings === null || settings === void 0 ? void 0 : settings.faq_display_type),
    faqTitle: (_settings$faq_title = settings === null || settings === void 0 ? void 0 : settings.faq_title) !== null && _settings$faq_title !== void 0 ? _settings$faq_title : defaultInfo.faqTitle,
    faqItems: withSubBrokerPortalItemId((_settings$faq_items = settings === null || settings === void 0 ? void 0 : settings.faq_items) !== null && _settings$faq_items !== void 0 ? _settings$faq_items : defaultInfo.faqItems)
  };
};
export var generateBrokerSubBrokerPortalInitialDataInfo = function generateBrokerSubBrokerPortalInitialDataInfo(data) {
  var _data$payload2, _settings$countries, _settings$login_intro, _settings$login_intro2;

  var settings = data === null || data === void 0 ? void 0 : (_data$payload2 = data.payload) === null || _data$payload2 === void 0 ? void 0 : _data$payload2.sub_broker_portal_settings;
  var countries = Array.isArray(settings === null || settings === void 0 ? void 0 : settings.countries) && settings !== null && settings !== void 0 && (_settings$countries = settings.countries) !== null && _settings$countries !== void 0 && _settings$countries.length ? settings.countries : ['GB'];
  var defaultLoginIntroInfo = getDefaultPortalLoginIntroInfo();
  return {
    activated: isBoolean(settings === null || settings === void 0 ? void 0 : settings.activated) ? settings.activated : false,
    countries: countries,
    currentCountry: countries[0] || '',
    countryConfig: countries.reduce(function (countryConfigMap, code) {
      var _settings$code;

      // Migrates legacy flat settings (saved before country versions) into the default country
      var countrySettings = (_settings$code = settings === null || settings === void 0 ? void 0 : settings[code]) !== null && _settings$code !== void 0 ? _settings$code : code === countries[0] ? settings : undefined;
      countryConfigMap[code] = generateSubBrokerPortalCountryConfigInitialDataInfo(countrySettings, data === null || data === void 0 ? void 0 : data.name, code);
      return countryConfigMap;
    }, {}),
    loginIntroDisplayType: subBrokerPortalModuleDisplayType(settings === null || settings === void 0 ? void 0 : settings.login_intro_display_type),
    loginIntroTitle: (_settings$login_intro = settings === null || settings === void 0 ? void 0 : settings.login_intro_title) !== null && _settings$login_intro !== void 0 ? _settings$login_intro : defaultLoginIntroInfo.title,
    loginIntroList: withSubBrokerPortalItemId((_settings$login_intro2 = settings === null || settings === void 0 ? void 0 : settings.login_intro_list) !== null && _settings$login_intro2 !== void 0 ? _settings$login_intro2 : defaultLoginIntroInfo.introList)
  };
};